import type { ParagraphTranslations } from "./pl";

export const de: ParagraphTranslations = {
  unsupportedLayout: (n) => `Absatztyp ${n}`,
  unsupportedLayoutBody:
    "— dieses Layout wird vom Renderer nicht unterstützt. Der Absatz existiert in der Datenbank, aber sein Layout wurde noch nicht in der Komponente implementiert.",

  attachments: {
    heading: "Anhänge",
    download: "Datei herunterladen",
    sizeMb: (mb) => `${mb} MB`,
  },

  gallery: {
    openImage: "Bild in voller Größe öffnen",
    image: "Bild",
    empty: "Keine Bilder in diesem Absatz.",
  },

  video: {
    youtubeTitleFallback: "YouTube-Video",
    missing: "Video ist nicht verfügbar (keine Quelle).",
  },

  blogPosts: {
    empty: "Keine zugehörigen Blogbeiträge.",
    open: (name) => `Beitrag öffnen: ${name}`,
    viewMore: "Mehr anzeigen",
  },

  map: {
    empty: "Keine Punkte auf der Karte anzuzeigen.",
    loading: "Karte wird geladen…",
  },

  contactForm: {
    heading: "Kontaktformular",
    labels: {
      phone: "Telefon",
      email: "E-Mail",
      text: "Nachricht",
      personalData:
        "Ich willige in die Verarbeitung meiner personenbezogenen Daten ein",
    },
    rodoDefault:
      "Ich willige in die Verarbeitung meiner personenbezogenen Daten zur Bearbeitung der Anfrage ein.",
    submit: "Nachricht senden",
    sending: "Senden…",
    validation: {
      requiredField: (label) => `Feld „${label}" ist erforderlich.`,
      invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
      invalidPhone: "Bitte geben Sie eine gültige Telefonnummer ein.",
      requiredPersonalData: "Einwilligung in die Datenverarbeitung erforderlich.",
    },
    status: {
      sendSuccess: "Nachricht gesendet. Danke für Ihre Anfrage.",
      sendFailed:
        "Nachricht konnte nicht gesendet werden. Bitte versuchen Sie es später erneut.",
      rateLimit:
        "Zu viele Versuche von dieser IP-Adresse. Bitte warten Sie einen Moment.",
      tokenExpired:
        "Formularsitzung abgelaufen. Seite neu laden und erneut versuchen.",
      antiSpam:
        "Verdächtige Aktivität erkannt. Bitte überprüfen Sie das Formular und versuchen Sie es erneut.",
      waitBeforeSubmit: (sec) =>
        `Bitte warten Sie noch ${sec} Sekunde(n), bevor Sie das Formular absenden.`,
      networkError: (msg) => `Netzwerkfehler: ${msg}.`,
      networkErrorGeneric:
        "Verbindung zum Server fehlgeschlagen. Bitte erneut versuchen.",
    },
  },
};
